import { gql } from '@apollo/client';

// ====================== QUERY ====================== //
const QUERY_ITEM = gql`
    query note($input: NoteInput!){
        note(input: $input){
            id
            uuid
            submitted_uuid
            type
            message
            note_file
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const QUERY_ITEMS = gql`
    query notes($input: NotesInput){
        notes(input: $input){
            id
            uuid
            submitted_uuid
            type
            message
            note_file
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const QUERY_LOOKUP_ITEMS = gql`
    query notes($input: NotesInput){
        notes(input: $input){
            # id
            uuid
            submitted_uuid
            type
            message
            # note_file
            company
            # created_at
            # created_by
            # updated_at
            # updated_by
        }
    }
`
const QUERY_ITEMS_BY_PAGE = gql`
    query notesByPage($input: NotesByPageInput!){
        notesByPage(input: $input){
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
            currentPage
            prevPage
            nextPage
            totalPages
            totalItems
            notes{
                id
                uuid
                submitted_uuid
                type
                message
                note_file
                company
                created_at
                created_by
                updated_at
                updated_by
            }
        }
    }
`
// ====================== MUTATION ====================== //
const MUTATION_CREATE_ITEM = gql`
    mutation createNote($input: CreateNoteInput!){
        createNote(input: $input){
            id
            uuid
            submitted_uuid
            type
            message
            note_file
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const MUTATION_CREATE_ITEMS = gql`
    mutation createNotes($input: [CreateNoteInput]!){
        createNotes(input: $input){
            id
            uuid
            submitted_uuid
            type
            message
            note_file
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const MUTATION_DELETE_ITEM = gql`
    mutation deleteNote($input: DeleteNoteInput!){
        deleteNote(input: $input){
            id
            uuid
            submitted_uuid
            type
            message
            note_file
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const MUTATION_DELETE_ITEMS = gql`
    mutation deleteNotes($input: DeleteNoteInput!){
        deleteNotes(input: $input){
            id
            uuid
            submitted_uuid
            type
            message
            note_file
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const MUTATION_EXPORT_ITEMS = gql`
    mutation exportNotes($input: NotesInput!, $by: ActionByInput!){
        exportNotes(input: $input, by: $by){
           uuid
           size
           key
           name
           status
           topic
           type
           url
           company
           created_at
           created_by
           updated_at
           updated_by
        }
    }
`
const MUTATION_UPDATE_ITEM = gql`
    mutation updateNote($input: UpdateNoteInput!){
        updateNote(input: $input){
            id
            uuid
            submitted_uuid
            type
            message
            note_file
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`

// ====================== CREATE GQL ====================== //
const noteGQL = {
    query: {
        getItem: QUERY_ITEM,
        getItems: QUERY_ITEMS,
        getLookupItems: QUERY_LOOKUP_ITEMS,
        getItemsByPage: QUERY_ITEMS_BY_PAGE,
    },
    mutation: {
        createItem: MUTATION_CREATE_ITEM,
        createItems: MUTATION_CREATE_ITEMS,
        deleteItem: MUTATION_DELETE_ITEM,
        deleteItems: MUTATION_DELETE_ITEMS,
        exportItems: MUTATION_EXPORT_ITEMS,
        updateItem: MUTATION_UPDATE_ITEM,
    },
    response: {
        getItem: "note",
        getItems: "notes",
        getLookupItems: "notes",
        getItemsByPage: "notesByPage",
        createItem: "createNote",
        createItems: "createNotes",
        deleteItem: "deleteNote",
        deleteItems: "deleteNotes",
        exportItems: "exportNotes",
        updateItem: "updateNote",
    }
}

// ====================== EXPORT ====================== //
export {
    noteGQL,
}